import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { servicesApiKeyStore } from '../../../api/masters/services-api-key-store';
import { SelectChainItem, SelectConfig, SelectResult } from '../../../components/select/select-chain.component';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';

interface Workorder {
  unitID: number;
  serviceID: number;
}

interface CreateWorkorderFormProps {
  name?: string;
  unitID?: number;
  isOrginalService?: boolean;
  handleSetSelectedServiceId: (value: number, fastFieldFormIDValue: number) => void;
}
export const ServiceList = ({
  name,
  unitID,
  isOrginalService,
  handleSetSelectedServiceId,
}: CreateWorkorderFormProps) => {
  // const [selectedService, setSelectedService] = useState<SelectResult>({ serviceID: 0 });
  const [currentServiceID, setCurrentServiceID] = useState<number>(0);
  const { data } = useLoadData<ApiResponse<any>>(servicesApiKeyStore.getRetestServices());
  useEffect(() => {
    if (isOrginalService) {
      setCurrentServiceID(0);
    }
  }, [isOrginalService]);

  // const handleFilterSelected = (selectedValue: SelectResult) => {
  //   const selectedValueID = selectedValue?.target?.value || 0;
  //   // Call setNewWorkorder with the correct object structure
  //   const newFastFieldFormID = data?.data?.filter((data: any) => data?.serviceID === selectedValueID)?.fastFieldFormID;
  //   handleSetSelectedServiceId(selectedValueID, newFastFieldFormID);
  //   console.log(47, selectedValueID);
  //   setSelectedService(selectedValueID);
  // };

  const handleFilterSelected = (event: any) => {
    const selectedValueID = event.target.value as number;

    // Find the corresponding item in the data array
    const selectedItem = data?.data?.find((item: any) => item.serviceID === selectedValueID);
    const newFastFieldFormID = selectedItem?.fastFieldFormID || null;

    // Call setNewWorkorder with the correct object structure
    handleSetSelectedServiceId(selectedValueID, newFastFieldFormID);

    setCurrentServiceID(selectedValueID);
  };

  return (
    <FormControl fullWidth style={{ marginBottom: '8px' }}>
      <InputLabel size="small" id="demo-simple-select-label" className="legendTxtBgWht">
        Select other service
      </InputLabel>
      <Select
        // style={{ width: '200px' }}
        size="medium"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={currentServiceID}
        label="Mapping Type"
        onChange={handleFilterSelected}
      >
        {data &&
          data.data.map((item: any) => (
            <MenuItem key={`${item.serviceID}-${item.serviceID}`} value={item.serviceID}>
              {item.serviceName}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
  // <SelectChainItem config={selectConfig} value={selectedService} onSelect={handleFilterSelected} />;
};
